import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { i18nFallbackLng, i18nSupportedLngs } from '@web/common';
import { germanErrorMap } from '../app/utils';
import { z } from 'zod';

void i18n
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`../../public/locales/${language}/${namespace}.json`),
    ),
  )
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: i18nFallbackLng,
    fallbackNS: 'common',
    load: 'languageOnly', // ignoring country codes
    supportedLngs: i18nSupportedLngs,
    interpolation: {
      escapeValue: false, // react escapes by default
    },
  });

export default i18n;

export function setZodErrorMap() {
  switch (i18n.language) {
    case 'de':
      z.setErrorMap(germanErrorMap);
      break;
    case 'en':
      break;
    default:
      break;
  }
}
